module.exports = __webpack_public_path__ + "static/media/book-red1.30907ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Amazon/book-red1.png
// module id = ./src/assets/Amazon/book-red1.png
// module chunks = 0